export default function MissionVision() {
  return (
    <section id="mission-vision" className="section">
      <h1 className="mission-vision-title">Mission & Vision.</h1>
      
      <div className="mission-vision-content">
        <div className="mission-section">
          <h3 className="mission-heading mb-1">MISSION</h3>
          <p className="mission-text">
            We believe innovation is the key to success, and every team member is a true partner in shaping our vision.
          </p>
          <p className="mission-text mb-1">
            Our mission is to deliver smart, user-friendly, and eco-conscious products that simplify communication, enhance brand image, and contribute to sustainability.
          </p>
        </div>

        <div className="vision-section">
          <h3 className="vision-heading mb-1">VISION</h3>
          <p className="vision-intro">
            To become a leader in smart digital communication, empowering individuals and businesses with:
          </p>
          <ul className="vision-list">
            <li>Innovative NFC-based digital solutions.</li>
            <li>Customizable smart designs tailored to all needs.</li>
            <li>Eco-friendly alternatives that reduce paper waste.</li>
            <li>Comprehensive services for individuals and enterprises.</li>
            <li>Full technical support for seamless user experience.</li>
            <li>A smarter, more sustainable way of connecting.</li>
          </ul>
        </div>
      </div>
    </section>
  )
}

